import { hotArticles } from "@/mocks/articles";

export default function HotArticles() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex items-center justify-between">
          <div>
            <span className="inline-flex rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 whitespace-nowrap">
              编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热门深度解析
            </h2>
          </div>
          <a
            href="/worldview"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
          >
            全部文章
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 space-y-5">
          {hotArticles.map((article) => (
            <a
              key={article.id}
              href={article.link}
              className="group grid grid-cols-1 gap-0 overflow-hidden rounded-2xl bg-background-100/70 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-0.5 sm:grid-cols-[240px_1fr]"
            >
              <div className="h-44 w-full overflow-hidden sm:h-full">
                <img
                  src={article.image}
                  alt={article.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col justify-center p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800">
                    {article.tag}
                  </span>
                  <span className="text-xs text-foreground-600">{article.category}</span>
                  <span className="text-xs text-foreground-600">·</span>
                  <span className="text-xs text-foreground-600">{article.date}</span>
                  <span className="text-xs text-foreground-600">· {article.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-700">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                  阅读全文
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}